export default "__VITE_ASSET__DFQmkMkQ__"